export const getSingleCourse = (payload?: any) => ({
    type: "@saga/GET_SINGLE_COURSE",
    payload
});

